export default {
  methods: {
    setTexts (rateVal) {
      let arr = []
      for(let i = 0;i < 5;i++){
        arr.push(rateVal)
      }
      return arr
    }
  }
}